import { FC, ReactNode } from "react";

import { ErrorNotice } from "./ErrorNotice";

import { ChatbotClassMap, ChatbotCx } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly cx: ChatbotCx;
  readonly hasError: boolean;
  readonly errorMessage: ReactNode;
  readonly children: ReactNode;
}

/** Holds the inline error banner and input box in the panel footer slot. */
export const PromptFooter: FC<Props> = ({ styles, cx, hasError, errorMessage, children }) => (
  <div className={styles.AgentChatbotFooter}>
    {!!hasError && <ErrorNotice styles={styles} errorMessage={errorMessage} />}
    <div className={cx(styles.AgentChatbotInput, hasError && styles.AgentChatbotInputAttached)}>{children}</div>
  </div>
);
